import consts, { KIND, ORDER_BY, SORT, PREDEFINED_TREE_NODES } from './consts';
import { recent, starred, myDrive, sharedDrive, sharedWithMe } from './predefinedTreeNodes';

const { CONTEXTS } = consts;

const createContextList = (ids = {}) => ({
  selected: [],
  lastSelectedIndex: -1,
  folders: {
    status: undefined,
    data: [],
    ids,
    cursor: undefined,
  },
  files: {
    status: undefined,
    data: [],
    cursor: undefined,
  },
});

export const createSearchContextList = (ids, params) => ({
  ...createContextList(ids),
  params: { term: undefined, ...params },
});

export const createAssetsContextList = (ids, params) => ({
  ...createContextList(ids),
  params: {
    id: PREDEFINED_TREE_NODES.MY_DRIVE,
    path: [PREDEFINED_TREE_NODES.MY_DRIVE],
    kind: KIND.MY_DRIVE,
    driveId: undefined,
    previousFolder: null,
    ...params,
  },
});

export const getNewContextList = (context, ids, params) =>
  context === CONTEXTS.SEARCH ? createSearchContextList(ids, params) : createAssetsContextList(ids, params);

export const getDefaultSortOrder = () => ({
  orderBy: ORDER_BY.NAME,
  sort: SORT.ASC,
});

export default () => ({
  __record: 'GoogleDriveRecord',
  lists: {
    requestId: 0,
    ASSETS: createAssetsContextList(),
    SEARCH: createSearchContextList(),
  },

  ...getDefaultSortOrder(),

  // contains data for the tree view (folders only)
  tree: {
    // the retrieve status for the each node
    statuses: {},
    // a flat list of folders loaded to the tree (each folder points to each children if it has any)
    folders: {
      ...myDrive,
      ...sharedDrive,
      ...sharedWithMe,
      ...recent,
      ...starred,
    },
  },

  currentContext: CONTEXTS.ASSETS,
  isSignedIn: false,
  user: null,
  isAuthInProgress: false,
  panelIsOpen: true,
  breadcrumbPath: [],
  fetchingUploadData: false,
  waitForSignIn: false,
  userNotLoggedIn: false,
});
